.legend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--bi-scale-3x) var(--bi-scale-8x);
    margin: var(--bi-scale-4x) 0 var(--bi-scale-8x);
    padding: var(--bi-scale-1x) 0;
    list-style: none;

    .legendItem {
        display: flex;
        align-items: center;
        gap: var(--bi-scale-3x);
        font: var(--bi-font-title-regular-xs);
        white-space: nowrap;
    }

    .swatch {
        flex-shrink: 0;
        box-sizing: border-box;
        width: var(--bi-scale-6x);
        height: var(--bi-scale-6x);
        border: var(--bi-stroke-thin) solid transparent;
        border-radius: var(--bi-radius-medium);

        &.swatchCourse {
            background: var(--bi-color-surface);
            border-color: var(--bi-color-stroke-strong);
        }

        &.swatchWebinar {
            border-color: color-mix(in srgb, var(--bi-basic-white) 40%, transparent);
        }

        &.swatchElective {
            border-style: dashed;
            border-color: var(--bi-primary-50);
        }
    }
}
